





































import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class AlertModal extends Vue {

    @Prop({
        required: false,
        type: String
    })
    private alertContent?: string

}
